import axios from "axios"

export async function getAppStatus(): Promise<any | undefined> {
  try {
    const r = await axios.get("/status")
    if (r && "version" in r.data) {
      return r.data
    } else {
      console.error("Failed to read app /status. Unexpected response:", r.data)
    }
  } catch (err) {
    console.error("Failed to read app /status", "error:", err)
  }
}

export async function getApiStatus(): Promise<any | undefined> {
  try {
    const r = await axios.get("/api/status")
    if (r && "version" in r.data) {
      return r.data
    } else {
      console.error("Failed to read API /status. Unexpected response:", r.data)
    }
  } catch (err) {
    console.error("Failed to read API /status", "error:", err)
    return "API unavailable"
  }
}
